import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class SeguimientoControlModel extends Model{
  defaults() {
    return {
      fecha: dateMethods.getDate()
      , tipoProceso: ''
      , tipoEjecucion: ''
      
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      fecha : fecha=> fecha
      , tipoProceso: tipoProceso=> tipoProceso
      , tipoEjecucion: tipoEjecucion=> tipoEjecucion
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/seguimiento/scheduled/seguimiento-control.js